export class Sticky {
  constructor() {
    window.addEventListener('load', this.fixedEvent);
    window.addEventListener('scroll', this.fixedEvent);
    window.addEventListener('resize', this.fixedEvent);
  }

  fixedEvent() {
    this.bg = document.querySelector('.bg');
    const rect = this.bg.getBoundingClientRect();
    const top = window.pageYOffset || document.documentElement.scrollTop;
    const fixedPos =  rect.top + top;

    if (window.pageYOffset > fixedPos) {
      this.bg.classList.add('is-fixed');
    } else {
      this.bg.classList.remove('is-fixed');
    }
  }
}
